import * as api from './api'
import { AppDispatch } from 'src/app/store'
import * as reducers from './slice-reducers'
import { convertToExcel, exportXLSXZip } from 'src/core/helpers'
import { FleetDataType, CalculateResultsType, payloadCalculateFootprint } from 'src/core/models'

export const getFleetList = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setFleetLoading(true))
    const data: FleetDataType[] = await api.getFleetAPI()
    dispatch(reducers.setFleetLoading(false))
    dispatch(reducers.setFleetData(data))
    dispatch(reducers.setFleetSuccessCreate(false))
    dispatch(reducers.setFleetSuccessDelete(false))
  } catch (error) {
    dispatch(reducers.setFleetLoading(false))
    dispatch(reducers.setFleetError(error))
  }
}

export const createOrEditFleet = (payload: FleetDataType, fleetId?: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setFleetLoading(true))
    const data: boolean = await api.createOrEditFleetAPI(payload, fleetId)
    dispatch(reducers.setFleetLoading(false))
    dispatch(reducers.setFleetSuccessCreate(data))
  } catch (error) {
    dispatch(reducers.setFleetLoading(false))
    dispatch(reducers.setFleetError(JSON.stringify(error)))
  }
}


export const deleteFleet = (fleetId: number) => async (dispatch: AppDispatch) => {
  try {
    const data: boolean = await api.deleteFleetAPI(fleetId)
    dispatch(reducers.setFleetSuccessDelete(data))
  } catch (error) {
    dispatch(reducers.setFleetLoading(false))
    dispatch(reducers.setFleetError(error))
  }
}

export const calculateFootprint = (payload: payloadCalculateFootprint) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setCalculateFootprintLoading(true))
    const data: CalculateResultsType[] = await api.calculateFootprintAPI(payload)
    dispatch(reducers.setCalculateFootprintLoading(false))
    dispatch(reducers.setCalculateFootprintResults(data))
  } catch (error) {
    dispatch(reducers.setCalculateFootprintLoading(false))
    dispatch(reducers.setCalculateFootprintError(error))
  }
}

export const downloadFile = (results: CalculateResultsType[]) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setDownloadFileLoading(true))
    const data = await api.downloadFileAPI(results[0].id)
    dispatch(reducers.setDownloadFileLoading(false))
    dispatch(reducers.setDownloadFileFileUrl(data))
    const book = convertToExcel(results[0], 'Calculate Results')
    await exportXLSXZip(
      'Cabify Results',
      [{ name: data.split('/').pop(-1),
        url: `${data}` }],
      'xlsx',
      book
    )
  } catch (error) {
    dispatch(reducers.setDownloadFileLoading(false))
    dispatch(reducers.setDownloadFileError(error))
  }
}
